module.exports = __webpack_public_path__ + "html/custom-template-task.component.html";